import { lengthFromDurationSeconds } from 'app/utils/duration-handler';
import type { Equipment } from 'app/types/graphql';

export interface LessonToWorkoutDetails {
  id: string;
  srcSet: string;
  title: string;
  additionalInfo: string;
  intensity: string;
  equipment?: Equipment[] | null;
  isSaved: boolean;
  isCompleted: boolean;
}

export interface FullLessonToWorkoutDetails extends LessonToWorkoutDetails {
  label?: string;
  isDisabled?: boolean;
  isDone?: boolean;
  link?: string;
}

type ExtraLessonToWorkoutDetails = Partial<FullLessonToWorkoutDetails>;

export const lessonToWorkout = (lesson: any, extraData?: ExtraLessonToWorkoutDetails): FullLessonToWorkoutDetails => ({
  id: lesson.id,
  srcSet: lesson.image?.url || lesson.image?.signedUrl,
  title: lesson.name || '',
  additionalInfo: lengthFromDurationSeconds(lesson.duration || 0),
  intensity: `RPE ${lesson.intensity}`,
  equipment: lesson.equipment,
  isSaved: !!lesson.isSaved,
  isCompleted: !!lesson.isCompleted,
  label: extraData?.label,
  isDisabled: extraData?.isDisabled,
  isDone: extraData?.isDone,
  link: extraData?.link,
});
